import {MissaoEntity} from "../../pages/_user/missao/missao.entity";


export const missaoAutocompleteOutput = (value: string | number, row: MissaoEntity) => {
  if (!row) {
    return { nomeMissao: value }
  }
  return { missaoId: row.id }
}
